<template>
  <validation-observer ref="simpleRules">

    <b-form>

      <b-tabs>
        <b-tab :title="$t('Condition')">
          <!-- Project Select -->
          <b-form-group
            :label="$t('Project')"
            label-for="mc-project"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Project')"
              rules="required"
            >
              <v-select
                id="vue-select-project"
                v-model="item.projectId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionProject"
                :reduce="project => project.id"
                label="projectName"
                :placeholder="$t('Select project...')"
                :state="errors.length > 0 ? false:null"
                @input="projectSelected"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>

          <!-- HotAlert Reason -->
          <b-form-group
            :label="$t('Condition Name')"
            label-for="mc-hot-alert-reason"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Condition Name')"
              rules="required"
            >
              <b-form-input
                v-model="item.hotAlertReason"
                :state="errors.length > 0 ? false:null"
                :placeholder="$t('Condition Name')"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>

          <form-filter
            v-if="item.projectId"
            v-model="item.filterConfig.filters"
            :project-id="item.projectId"
          />

          <b-row>
            <b-col>
              <!-- Status -->
              <b-form-group
                :label="$t('Status')"
                label-for="mc-status"
              >
                <b-form-checkbox
                  id="checkbox-status-page"
                  v-model="item.status"
                  name="checkbox-status-page"
                  switch
                >
                  {{ $t('Active') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col>
              <!-- Approval -->
              <b-form-group
                :label="$t('Approval/HotAlert')"
                label-for="mc-approval"
              >
                <b-form-checkbox
                  id="checkbox-approval-page"
                  v-model="item.approval"
                  name="checkbox-approval-page"
                  switch
                >
                  <span v-if="item.approval">{{ $t('Approval2') }}</span>
                  <span v-if="!item.approval">{{ $t('HotAlert') }}</span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

        </b-tab>
        <!-- Auto Assign tab -->
        <b-tab
          :title="$t('Auto Assign')"
        >
          <b-row>
            <!-- Question -->
            <b-col>
              <b-form-group
                label="Assign By"
                label-for="vue-select-question"
              >
                <v-select
                  id="vue-select-question"
                  v-model="item.autoAssignQuestionName"
                  :options="optionQuestion"
                  :reduce="q => q.questionName"
                  label="questionText"
                  :placeholder="$t('Select question...')"
                  :disabled="item.autoAssignEmail!==null"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Direct User Assignment -->
            <b-col>
              <b-form-group
                :label="$t('Assign To')"
                label-for="mc-assigned-to"
              >
                <v-select
                  id="vue-select-assigned-to"
                  v-model="item.autoAssignEmail"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionUser"
                  :reduce="user => user.email"
                  label="fullName"
                  :placeholder="$t('Select...')"
                  :disabled="item.autoAssignQuestionName!==null"
                />
              </b-form-group>

            </b-col>
            <!-- Action Plan -->
            <b-col>
              <b-form-group
                :label="$t('Action Planned')"
                label-for="mc-action-planned"
              >
                <v-select
                  id="vue-select-action-planned"
                  v-model="item.autoAssignAction"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionActionPlan||[]"
                  :placeholder="$t('Select...')"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>

          </b-row>

          <b-row v-if="!item.approval">
            <!-- Interval -->
            <b-col>
              <b-form-group
                :label="$t('Duration')"
                label-for="autoAssignInterval"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Duration')"
                  rules="between:1,99"
                >
                  <b-form-input
                    v-model="item.autoAssignInterval"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('1-99')"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Interval Type -->
            <b-col>
              <b-form-group
                :label="$t('Duration Type')"
                label-for="autoAssignIntervalType"
              >
                <v-select
                  id="autoAssignIntervalType"
                  v-model="item.autoAssignIntervalType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionIntervalType"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>

            <!-- Interval Time -->
            <b-col>
              <b-form-group
                :label="$t('Timing')"
                label-for="autoAssignIntervalTime"
              >
                <b-form-input
                  v-model="item.autoAssignIntervalTime"
                  placeholder="00:00"
                />
              </b-form-group>
            </b-col>

          </b-row>

          <!-- Description -->
          <b-row v-if="!item.approval">
            <b-col>
              <b-form-group
                :label="$t('Action Description')"
                label-for="mc-description"
              >
                <b-form-textarea
                  v-model="item.autoAssignDescription"
                  :placeholder="$t('Description...')"
                />

              </b-form-group>
            </b-col>
          </b-row>

        </b-tab>

        <!-- Auto Close tab -->
        <b-tab
          v-if="!item.approval"
          :title="$t('Auto Close')"
        >
          <b-row>
            <!-- Action -->
            <b-col sm="6">
              <b-form-group
                :label="$t('Close Action')"
                label-for="mc-close-action"
              >
                <v-select
                  id="vue-select-close-action"
                  v-model="item.autoCloseAction"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionCloseAction||[]"
                  :placeholder="$t('Select...')"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>
            <!-- Interval -->
            <b-col sm="2">
              <b-form-group
                :label="$t('Duration')"
                label-for="autoCloseInterval"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Duration"
                  rules="between:1,99"
                >
                  <b-form-input
                    v-model="item.autoCloseInterval"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('1-99')"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Interval Type -->
            <b-col>
              <b-form-group
                :label="$t('Duration Type')"
                label-for="autoCloseIntervalType"
              >
                <v-select
                  id="autoCloseIntervalType"
                  v-model="item.autoCloseIntervalType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionIntervalType"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>

          </b-row>

          <!-- Description -->
          <b-row>
            <b-col>
              <b-form-group
                :label="$t('Close Description')"
                label-for="mc-close-description"
              >
                <b-form-textarea
                  v-model="item.autoCloseDescription"
                  :placeholder="$t('Description...')"
                />

              </b-form-group>
            </b-col>
          </b-row>

        </b-tab>

      </b-tabs>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import FormFilter from '@/layouts/components/forms/FormFilter.vue'

import {
  BFormGroup, BForm, BFormCheckbox, BFormInput, BRow, BCol, BTabs, BTab, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormCheckbox,
    BFormInput,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormTextarea,
    vSelect,
    FormFilter,
  },
  directives: {
    Ripple,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        projectId: null,
        hotAlertReason: null,
        filterConfigJson: null,
        filterConfig: { filters: [] },
        waitApproval: false,
        status: true,
        approval: false,
        autoAssignQuestionName: null,
        autoAssignEmail: null,
        autoAssignAction: null,
        autoAssignInterval: 1,
        autoAssignIntervalType: 'business days',
        autoAssignDescription: null,
        autoCloseInterval: 1,
        autoCloseIntervalType: 'business days',
        autoCloseDescription: null,
        autoCloseAction: null,
      },
      required,
      optionProject: [],
      optionUser: [],
      optionQuestion: [],
      optionActionPlan: [],
      optionCloseAction: [],
      optionIntervalType: [
        'days', 'business days',
      ],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  watch: {
    item() {
      this.getQuestionOptions()
    },
  },
  async created() {
    this.getProjectOptions()
    this.getUserOptions()
    this.getQuestionOptions()
    this.getActionPlanOptions()
    this.getCloseActionOptions()
  },
  methods: {
    projectSelected() {
      this.getQuestionOptions()
      this.getActionPlanOptions()
      this.getCloseActionOptions()
    },
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data
      })
    },
    getQuestionOptions() {
      if (this.item.projectId) {
        useJwt.axiosIns.get(`question/${this.item.projectId}/shortlist`).then(response => {
          this.optionQuestion = response.data.filter(q => q.questionType === 0 || q.questionType === 1 || q.questionType === 2)
        })
      }
    },
    getActionPlanOptions() {
      if (this.item.projectId) {
        useJwt.axiosIns.get(`hotalert/${this.item.projectId}/ActionPlanOptions`).then(response => {
          if (response.data) {
            this.optionActionPlan = response.data
          }
        })
      }
    },
    getCloseActionOptions() {
      if (this.item.projectId) {
        useJwt.axiosIns.get(`hotalert/${this.item.projectId}/CloseActionOptions`).then(response => {
          if (response.data) {
            this.optionCloseAction = response.data
          }
        })
      }
    },
    getUserOptions() {
      useJwt.axiosIns.get('user/short').then(response => {
        this.optionUser = response.data
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const postItem = JSON.parse(JSON.stringify(this.item))
          postItem.filterConfigJson = JSON.stringify(postItem.filterConfig)
          if (postItem.id) {
            useJwt.axiosIns.patch('hotalert/condition', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('hotalert/condition', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
